exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "dimensions-editor {\n  display: block;\n  padding-left: 5px;\n}\ndimensions-editor h5 {\n  margin-bottom: 0;\n}\ndimensions-editor .dimensions-row {\n  margin-top: 5px;\n  margin-left: -20px;\n}\ndimensions-editor .add-new {\n  margin-left: 0;\n  padding: 4px;\n  width: 100%;\n}\n", ""]);

